<h4 class="p-3" *ngIf="hasAddress(patientDetails?.address?.[0])|| hasAddress(patientDetails?.address?.[1])">
    {{ 'ENTITY.PATIENT' | translate }} {{ 'LABEL.ADDRESS_LABEL' | translate }}
</h4>
<mat-divider></mat-divider>

<div class="row m-b-20" *ngIf="patientDetails?.address">
    <div class="col-lg-6" *ngIf="patientDetails?.address?.[0] as permanent">

        <div class="patient-details m-t-10">
            <h4 class="m-b-10" *ngIf="hasAddress(patientDetails?.address?.[0])">Permanent Address</h4>
            <div class="detail-item" *ngIf="permanent.address1">
                <label>{{ 'LABEL.ADDRESS_LABEL' | translate }}1:</label>
                <span>{{ permanent.address1 }}</span>
            </div>
            <div class="detail-item" *ngIf="permanent.address2">
                <label>{{ 'LABEL.ADDRESS_LABEL' | translate }}2:</label>
                <span>{{ permanent.address2 }}</span>
            </div>

            <div class="detail-item" *ngIf="permanent.district">
                <label>{{ 'LABEL.DISTRICT' | translate }}:</label>
                <span>{{ permanent.district }}</span>
            </div>

            <div class="detail-item" *ngIf="permanent.taluka">
                <label>{{ 'LABEL.TALUKA' | translate }}:</label>
                <span>{{ permanent.taluka }}</span>
            </div>
            <div class="detail-item" *ngIf="permanent.area">
                <label>{{ 'LABEL.AREA' | translate }}:</label>
                <span>{{ permanent.area }}</span>
            </div>
            <div class="detail-item" *ngIf="permanent.pincode">
                <label>{{ 'LABEL.PINCODE_LABEL' | translate }}:</label>
                <span>{{ permanent.pincode }}</span>
            </div>

            <div class="detail-item" *ngIf="permanent.state">
                <label>{{ 'LABEL.STATE' | translate }}:</label>
                <span>{{ permanent.state }}</span>
            </div>

            <div class="detail-item" *ngIf="permanent.country">
                <label>{{ 'LABEL.COUNTRY' | translate }}:</label>
                <span>{{ permanent.country }}</span>
            </div>
        </div>
    </div>

    <div class="col-lg-6" *ngIf="patientDetails?.address?.[1] as current">

        <div class="patient-details m-t-10">
            <h4 class="m-b-10" *ngIf="hasAddress(patientDetails?.address?.[1])">Current Address</h4>
            <div class="detail-item" *ngIf="current.address1">
                <label>{{ 'LABEL.ADDRESS_LABEL' | translate }}1:</label>
                <span>{{ current.address1 }}</span>
            </div>
            <div class="detail-item" *ngIf="current.address2">
                <label>{{ 'LABEL.ADDRESS_LABEL' | translate }}2:</label>
                <span>{{ current.address2 }}</span>
            </div>

            <div class="detail-item" *ngIf="current.district">
                <label>{{ 'LABEL.DISTRICT' | translate }}:</label>
                <span>{{ current.district }}</span>
            </div>

            <div class="detail-item" *ngIf="current.taluka">
                <label>{{ 'LABEL.TALUKA' | translate }}:</label>
                <span>{{ current.taluka }}</span>
            </div>
            <div class="detail-item" *ngIf="current.area">
                <label>{{ 'LABEL.AREA' | translate }}:</label>
                <span>{{ current.area }}</span>
            </div>
            <div class="detail-item" *ngIf="current.pincode">
                <label>{{ 'LABEL.PINCODE_LABEL' | translate }}:</label>
                <span>{{ current.pincode }}</span>
            </div>

            <div class="detail-item" *ngIf="current.state">
                <label>{{ 'LABEL.STATE' | translate }}:</label>
                <span>{{ current.state }}</span>
            </div>

            <div class="detail-item" *ngIf="current.country">
                <label>{{ 'LABEL.COUNTRY' | translate }}:</label>
                <span>{{ current.country }}</span>
            </div>
        </div>
    </div>
</div>

<h4 class="p-3" *ngIf="patientDetails?.contactInfo?.[0]?.contact||patientDetails?.contactInfo?.[0]?.email">
    {{ 'ENTITY.PATIENT' | translate }} {{ 'LABEL.CONTACT_DETAILS' | translate }}
</h4>
<mat-divider></mat-divider>

<div class="row m-b-20" *ngIf="patientDetails?.contactInfo">

    <div class="col-lg-6" *ngIf="patientDetails?.contactInfo?.[0] as contact">
        <div class="patient-details m-t-10">
            <div class="detail-item" *ngIf="contact.contact">
                <label>{{ 'LABEL.MOBILE_LABEL' | translate }}:</label>
                <span>{{ contact.contact }}</span>
            </div>
            <div class="detail-item" *ngIf="contact.email">
                <label>{{ 'LABEL.EMAIL_LABEL' | translate }}:</label>
                <span>{{ contact.email }}</span>
            </div>
        </div>
    </div>
</div>